import React, { useState, useEffect } from "react"
import withStyles from "react-jss"
import colors from "../data/colors"
import { results } from "../data/results"
import {
  RESULTS_FADEIN,
  RESULTS_FADEOUT,
  SECTION_DURATION,
} from "../data/globalStyles"

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    padding: "3rem",
    boxSizing: "border-box",
    "@media only screen and (max-width: 480px)": {
      marginTop: "3rem",
    },
    animation: ({ show }) =>
      `${
        show ? `$${RESULTS_FADEIN}` : `$${RESULTS_FADEOUT}`
      } ${SECTION_DURATION} ease-in-out`,
  },
  [`@keyframes ${RESULTS_FADEIN}`]: {
    from: {
      opacity: 0,
    },
    to: {
      opacity: 1,
    },
  },
  [`@keyframes ${RESULTS_FADEOUT}`]: {
    from: {
      opacity: 1,
    },
    to: {
      opacity: 0,
    },
  },
  wrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    width: "100%",
    maxWidth: "500px",
    "@media only screen and (max-width: 720px)": {
      width: "100%",
      maxWidth: "100%",
    },
  },
  heading: {
    color: colors.black,
    fontWeight: 600,
    lineHeight: 1.4,
    fontSize: "calc(24px + (32 - 24) * ((100vw - 300px) / (1600 - 300)))",
    margin: 0,
  },
  resultContainer: {
    width: "100%",
    maxWidth: "500px",
    marginBottom: "2rem",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  resultTitle: {
    // margin: 0,
    color: colors.black,
    fontWeight: 600,
    lineHeight: 1.5,
    fontSize: "calc(18px + (26 - 18) * ((100vw - 300px) / (1600 - 300)))",
  },
  dek: {
    fontWeight: 400,
    // fontSize: "calc(16px + (18 - 16) * ((100vw - 300px) / (1600 - 300)))",
    marginBottom: "0.5rem",
    lineHeight: 1.4,
  },
  recipe: {
    display: "inline-flex",
    textDecoration: "none",
    letterSpacing: "0.125em",
    fontFamily: "FuturaPT, sans-serif",
    fontSize: "12px",
    fontWeight: 600,
    textAlign: "center",
    color: colors.white,
    background: colors.black,
    border: `2px solid ${colors.black}`,
    boxSizing: "border-box",
    margin: "1rem 0",
    padding: "0.25rem .75rem",
    "&:hover": {
      color: colors.black,
      backgroundColor: colors.white,
    },
    "&:focus": {
      color: colors.black,
      backgroundColor: colors.white,
    },
  },
  restart: {
    letterSpacing: "0.125em",
    fontFamily: "FuturaPT, sans-serif",
    padding: "0.25rem .75rem",
    fontSize: 12,
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textDecoration: "none",
    textAlign: "center",
    boxSizing: "border-box",
    backgroundColor: colors.yellow,
    border: `2px solid ${colors.yellow}`,
    color: colors.black,
    transition: "background-color 0.2s ease-in-out",
    "&:hover": {
      color: colors.black,
      backgroundColor: `${colors.white}`,
    },
    "&:focus": {
      color: colors.black,
      backgroundColor: colors.white,
    },
  },
}

const Results = ({
  classes,
  show,
  setShow,
  section,
  ids,
  onAnimationEnd,
  setResetQuiz,
}) => {
  const INITIAL_RESULT_DATA = {
    resultID: 0,
    result: "",
  }
  const [renderData, setRenderData] = useState(INITIAL_RESULT_DATA)

  useEffect(() => {
    if (ids.length === 1) {
      const result = results.filter((dish) => dish.resultID === ids[0])[0]
      if (result) {
        setRenderData(result)
      }
    }
  }, [ids])

  const restartQuiz = () => {
    // reset all previous calculations
    setShow((d) => ({
      ...d,
      intro: true,
      results: false,
    }))
    setTimeout(() => {
      setRenderData(INITIAL_RESULT_DATA)
      setResetQuiz(true)
    }, 1000)

    if (window.parent && window.parent.dataLayer) {
      window.parent.dataLayer.push({
        event: "datavisualization-baSidesQuiz-restartButton",
      })
    }
  }

  const openLink = (item) => {
    window.open(item, "_blank")
    if (window.parent && window.parent.dataLayer) {
      window.parent.dataLayer.push({
        event: "datavisualization-baSidesQuiz-recipeClick",
        "gtm.elementUrl": item,
      })
    }
  }

  return (
    section === "results" && (
      <footer className={classes.container} onAnimationEnd={onAnimationEnd}>
        <div className={classes.wrapper}>
          <h3 className={classes.heading}>{renderData.hed}</h3>
          <p className={classes.dek}>{renderData.snippet}</p>
          <div className={classes.resultContainer}>
            <img
              className={classes.image}
              src={renderData.imgURL}
              alt={`${renderData.result}`}
            />
            <h3 className={classes.resultTitle}>{renderData.result}</h3>
            <p className={classes.dek}>{renderData.dek}</p>
            <a
              className={classes.recipe}
              href={renderData.URL}
              onClick={() => openLink(renderData.URL)}
              target="_blank"
              rel="noreferrer">
              VIEW RECIPE
            </a>
          </div>
        </div>
        <button className={classes.restart} onClick={restartQuiz}>
          TAKE THE QUIZ AGAIN
        </button>
      </footer>
    )
  )
}

export default withStyles(styles)(Results)
